import BookItButton from './BookItButton';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { isValid } from 'redux-form';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { bookAppt, doReschedule } from 'store/reducers/appointment/actions';
import { gtmUserEvent, gtmRecaptchaEvent } from 'store/reducers/gtm/actions';
import {
  setContactInfoMissing,
  mobilePhoneNumberPopulated,
  setRecaptchaToken
} from 'store/reducers/userInteractions/actions';
import { getOptStatus, getOptInUrl } from 'store/reducers/marketing/actions';

// Selectors
import {
  getParticipantComments,
  getPrivacySettings,
  getAttendanceStatus,
  getTransportationOption,
  getTotalPrice,
  isLeadAppt,
  isNewLeadAppt,
  getStartTime,
  isCarryOver,
  isDmsAppt,
  isModifyAppt
} from 'store/reducers/appointment/selectors';
import { getTransportOptions } from 'store/reducers/apptOptions/selectors';
import {
  isApptModified,
  isModifyEnabled,
  isBookingEnabled,
  isContactInfoFormValid
} from 'store/reducers/userInteractions/selectors';
import {
  getMarketingSMSConfiguration,
  isLicenseNumberValid,
  getExternalValetProvider,
  isRecaptchaEnabledOnConfirmAppt,
  isRecaptchaEnabledOnRescheduleAppt,
  getRecaptchaToken
} from 'store/reducers/dealerSettings/selectors';
import {
  getCTABanner,
  getShowBookItButtonLabel
} from 'store/reducers/optimizelyABTest/selectors';
import { getLanguageCode } from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = state => ({
  notes: getParticipantComments(state),
  totalPrice: getTotalPrice(state),
  isBookingEnabled: isBookingEnabled(state),
  privacySettings: getPrivacySettings(state),
  appointmentStatus: getAttendanceStatus(state),
  transportationOption: getTransportationOption(state),
  transportations: getTransportOptions(state),
  isApptModified: isApptModified(state),
  isModifyEnabled: isModifyEnabled(state),
  isDmsAppt: isDmsAppt(state),
  isLeadAppt: isLeadAppt(state),
  isNewLeadAppt: isNewLeadAppt(state),
  startTime: getStartTime(state),
  isContactInfoFormValid: isContactInfoFormValid(state),
  isFormRemindersValid: isValid('RemindersForm')(state),
  isLicenseNumberValid: isLicenseNumberValid(state),
  marketingSMSConfiguration: getMarketingSMSConfiguration(state),
  ctaBanner: getCTABanner(state),
  isCarryOver: isCarryOver(state),
  externalValet: getExternalValetProvider(state),
  showBookItButtonLabel: getShowBookItButtonLabel(state),
  isModifyAppt: isModifyAppt(state),
  isRecaptchaEnabledOnConfirmAppt: isRecaptchaEnabledOnConfirmAppt(state),
  isRecaptchaEnabledOnRescheduleAppt: isRecaptchaEnabledOnRescheduleAppt(state),
  languageCode: getLanguageCode(state),
  recaptchaToken: getRecaptchaToken(state)
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      goTo,
      bookAppt,
      doReschedule,
      gtmUserEvent,
      setContactInfoMissing,
      mobilePhoneNumberPopulated,
      getOptStatus,
      getOptInUrl,
      setRecaptchaToken,
      gtmRecaptchaEvent
    },
    dispatch
  );
}

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BookItButton);



// WEBPACK FOOTER //
// ./src/components/molecules/BookItButton/BookItButtonContainer.js